import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "../ui/button";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const HeroSection = ({ settings }) => {
    const { title, subheading, backgroundImage, ctaText, ctaLink, mode, images } = settings;

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    if (mode === 'carousel' && images && images.length > 0) {
        return (
            <div className="relative w-full h-[500px] md:h-[400px] bg-gray-900 text-white overflow-hidden group hero-carousel">
                <Carousel
                    key={images.length}
                    responsive={responsive}
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    showDots={true}
                    arrows={false}
                    className="h-full"
                    containerClass="h-full"
                    itemClass="h-full"
                >
                    {images.map((img, index) => (
                        <div key={index} className="w-full h-full relative">
                            <img 
                                src={img} 
                                alt={`Slide ${index}`} 
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-black/40" />
                        </div>
                    ))}
                </Carousel>
                
                <div className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none">
                    <div className="text-center px-4 max-w-3xl mx-auto pointer-events-auto">
                        {title && (
                            <h1 className="text-6xl md:text-4xl font-bold mb-4 tracking-tight drop-shadow-lg animate-in fade-in slide-in-from-bottom-8 duration-700">
                                {title}
                            </h1>
                        )}
                        {subheading && (
                            <p className="text-xl md:text-lg mb-8 text-gray-200 drop-shadow-md animate-in fade-in slide-in-from-bottom-8 duration-700 delay-150">
                                {subheading}
                            </p>
                        )}
                        {ctaText && ctaLink && (
                            <Link to={ctaLink}>
                                <Button 
                                    size="lg" 
                                    className="rounded-full px-8 py-6 text-lg md:px-6 md:py-4 md:text-base font-semibold bg-white text-black hover:bg-gray-100 transition-all hover:scale-105 shadow-xl animate-in fade-in slide-in-from-bottom-8 duration-700 delay-300"
                                >
                                    {ctaText}
                                </Button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative w-full h-[500px] md:h-[400px] flex items-center justify-center text-center bg-gray-900 text-white overflow-hidden">
            {backgroundImage && (
                <div 
                    className="absolute inset-0 bg-cover bg-center z-0 transition-transform duration-700 hover:scale-105"
                    style={{ backgroundImage: `url(${backgroundImage})` }}
                />
            )}
            <div className="absolute inset-0 bg-black/40 z-10" />
            
            <div className="relative z-20 px-4 max-w-3xl mx-auto animate-in fade-in slide-in-from-bottom-8 duration-700">
                {title && (
                    <h1 className="text-6xl md:text-4xl font-bold mb-4 tracking-tight drop-shadow-lg">
                        {title}
                    </h1>
                )}
                {subheading && (
                    <p className="text-xl md:text-lg mb-8 text-gray-200 drop-shadow-md">
                        {subheading}
                    </p>
                )}
                {ctaText && ctaLink && (
                    <Link to={ctaLink}>
                        <Button 
                            size="lg" 
                            className="rounded-full px-8 py-6 text-lg md:px-6 md:py-4 md:text-base font-semibold bg-white text-black hover:bg-gray-100 transition-all hover:scale-105 shadow-xl"
                        >
                            {ctaText}
                        </Button>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default HeroSection;
